module.exports = __webpack_public_path__ + "img/23.db612656.png";